import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { GiftCardContactModel, GiftCardClientsModel } from 'src/app/models/gifcardVirtual.model';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'clients-add-update',
    templateUrl: 'clients-add-update.component.html',
    styleUrls: ['clients-add-update.component.css']
})

export class ClientComponent implements OnInit {
    constructor(private giftCardService: GifcardVirtualService, 
        private formBuilder: FormBuilder, 
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private authService: AuthService) { }

    id_cliente: number;
    id_contact: number;
    isNewClient: boolean = true;
    clientsFormGroup: FormGroup; 
    contactFormGroup: FormGroup;
    selectContact: GiftCardContactModel;
    datasourceSelectContact: GiftCardContactModel[] = [];
    colsTablaContactos: any[]; 
    dlgContacto:boolean = false;
    isNewContact = true;

    currentUser: string;
    loading: boolean = false;
    model;

    ngOnInit() {
        this.currentUser = this.authService.getCurrentUser();
        this.model = JSON.parse(this.giftCardService.getClientEdit());
        this.createClientForm();      
        this.createContactForm();  
        this.createColumnsTablaContacts();     
        if (this.model != null){
            this.isNewClient = false;
            this.id_cliente = this.model.ID_CLIENTE;
            this.clientsFormGroup.get('nroRuc').disable();
            this.clientsFormGroup.get('nroRuc').setValue(this.model.NRORUC_CLIENTE);
            this.clientsFormGroup.get('razonSocial').setValue(this.model.RAZSOC_CLIENTE);
            this.populateSelectContact();
        }
        else{
            this.isNewClient = true;
            this.datasourceSelectContact = [];
        }
           
    }

    createColumnsTablaContacts(){
        this.colsTablaContactos = [           
            { field: 'NOMBRE_CONTACTO', header: 'Nombres y Apellidos' },
            { field: 'CORREO_CONTACTO', header: 'Correo Electrónico' },
            { field: 'ESTADO', header: 'ESTADO'}
        ];
    }

    createClientForm(){
        this.clientsFormGroup = this.formBuilder.group({
            nroRuc: ['', [Validators.required, Validators.pattern('[0-9]*')]],
            razonSocial: ['', Validators.required]
        });
    }

    createContactForm(){
        this.contactFormGroup = this.formBuilder.group({
            nombreContacto: ['', Validators.required],
            emailContacto: ['', [Validators.required, Validators.email]]
        });
    }

    populateSelectContact(){        
        let client = {
            "p_id_cliente_gift_card": this.id_cliente
        };
        this.giftCardService.GetContactAllByClient(client).subscribe(
            (response: GiftCardContactModel[]) => {
                this.datasourceSelectContact = response;   
                this.loading = false;     
            },
            (error) => {
                this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al listar contactos.'});
            }
        )
    }

    saveCliente(){
        if (this.clientsFormGroup.valid){
            this.loading = true;
            if (this.isNewClient){
            
                let client = {
                    "p_ruc_cliente": this.clientsFormGroup.get('nroRuc').value,
                    "p_razon_cliente": this.clientsFormGroup.get('razonSocial').value,
                    "p_creationuser": this.currentUser
                };    
                this.giftCardService.CreateClient(client).subscribe(
                    (response) => {
                        let json = response;      
                        if (json.NEW_ID_CLIENTE == -1){
                            this.messageService.add({severity:'error', summary: 'Error', detail:'El RUC ya fue registrado con anterioridad.'});
                        }
                        else{
                            this.id_cliente = json.NEW_ID_CLIENTE; 
                            this.isNewClient = false;    
                            this.isNewContact = true;      
                            this.messageService.add({severity:'success', summary: 'Éxito', detail:'El cliente se registró correctamente.'});
                        }  
                        this.loading = false;         
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                        this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al registrar cliente'});
                    }
                )           
            }
            else{
                
                let client = {
                    "p_id_cliente": this.id_cliente,
                    "p_ruc_cliente": this.clientsFormGroup.get('nroRuc').value,
                    "p_razon_cliente": this.clientsFormGroup.get('razonSocial').value,
                    "p_flag_activo": 1
                };    
                this.giftCardService.UpdateClient(client).subscribe(
                    (response) => {          
                        this.loading = false;     
                        this.messageService.add({severity:'success', summary: 'Éxito', detail:'El cliente se actualizó correctamente'});
                    },
                    (error) => {
                        this.loading = false;
                        this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al actualizar cliente'});
                    }
                )
            }
        }
        else{
            this.messageService.add({severity:'warn', summary: 'Alerta', detail:'Debe ingresar todos los campos obligatorios'});
        }
    }

    saveContacto(){
        if (this.contactFormGroup.valid){
            this.loading = true;
            if (this.isNewContact){
                let contact = {
                    "p_id_cliente" : this.id_cliente,
                    "p_nombre_contacto": this.contactFormGroup.get('nombreContacto').value,
                    "p_correo_contacto": this.contactFormGroup.get('emailContacto').value,
                    "p_creationuser": this.currentUser
                };
        
                this.giftCardService.CreateContact(contact).subscribe(
                    (response) => {
                        this.populateSelectContact();
                        this.dlgContacto = false;    
                        this.messageService.add({severity:'success', summary: 'Éxito', detail:'El contacto se registró correctamente.'});
                    },
                    (error) => {
                        this.loading = false;
                        this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al registrar contacto'});
                    }
                )
            }else{
                let contact = {
                    "p_id_contact" : this.id_contact,
                    "p_id_cliente" : this.id_cliente,
                    "p_nombre_contacto": this.contactFormGroup.get('nombreContacto').value,
                    "p_correo_contacto": this.contactFormGroup.get('emailContacto').value,
                    "p_flag_activo": 1
                };    
                this.giftCardService.UpdateContact(contact).subscribe(
                    (response) => {
                        this.populateSelectContact();
                        this.messageService.add({severity:'success', summary: 'Éxito', detail:'El contacto se actualizó correctamente.'});
                        this.dlgContacto = false;    
                    },
                    (error) => {
                        this.loading = false;
                        this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al actualizar contacto'});
                    }
                )
            }
        }
        else{
            this.messageService.add({severity:'warn', summary: 'Alerta', detail:'Debe ingresar todos los campos obligatorios'});
        }
    }

    onRowSelect(event){
        let itemContact = event.data;
        this.isNewContact = false;
        this.id_contact = itemContact.ID_CONTACT;
        this.contactFormGroup.get('nombreContacto').setValue(itemContact.NOMBRE_CONTACTO);
        this.contactFormGroup.get('emailContacto').setValue(itemContact.CORREO_CONTACTO);
        this.dlgContacto = true;
    }

    onShowConfirmDeBaja(contact: GiftCardContactModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro dar de baja al contacto?',
            accept: () => {                          
                this.lowContact(contact);
            }
        });
    }

    lowContact(contact: GiftCardContactModel){
        this.loading = true; 
        let params = {
            "p_id_contact" : contact.ID_CONTACT,
            "p_id_cliente" : contact.ID_CLIENTE,
            "p_nombre_contacto": contact.NOMBRE_CONTACTO,
            "p_correo_contacto": contact.CORREO_CONTACTO,
            "p_flag_activo": 0
        };       
        this.giftCardService.UpdateContact(params).subscribe(
            (response) => {          
                this.loading = false;     
                this.populateSelectContact();
                this.messageService.add({severity:'success', summary: 'Éxito', detail:'El contacto se dió de baja correctamente'});
            },
            (error) => {
                this.loading = false;
                this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrio un error al dar de baja al contacto'});
            }
        )
    }

    showDlgContacto(){
        this.dlgContacto = true;
        this.cleanContacto();
    }

    closeDlgContacto(){
        this.dlgContacto = false;
    }

    onBack(){
        this.giftCardService.removeClientEdit();      
    }

    cleanContacto(){
        this.isNewContact = true;
        this.contactFormGroup.get('nombreContacto').reset();
        this.contactFormGroup.get('emailContacto').reset();
    }

    get ruc_cliente2(){
        return this.clientsFormGroup.get('nroRuc');
    }

    get razon_cliente2(){
        return this.clientsFormGroup.get('razonSocial');
    }

    get nombre_contacto2(){
        return this.contactFormGroup.get('nombreContacto');
    }

    get email_contacto2(){
        return this.contactFormGroup.get('emailContacto');
    }
}